import script from "./m-form-group.vue?vue&type=script&setup=true&lang=js"
export * from "./m-form-group.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__